// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fP8p","question":"styles_question__2J7wW","description":"styles_description__3MYSU"};